(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
    this.initNavCarousel();
  }

  initNavCarousel() {
    const wrapper = document.getElementById('nav-carousel-wrapper');
    const carousel = document.getElementById('nav-carousel');
    const prevBtn = document.getElementById('nav-prev');
    const nextBtn = document.getElementById('nav-next');
    if (!wrapper || !carousel) return;

    let offset = 0;
    const STEP = 200;
    const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);
    const maxOff = () => Math.max(0, carousel.scrollWidth - wrapper.clientWidth);

    // ===========================================================
    // TELEPORT DROPDOWN SYSTEM
    // Theme JS / CSS thi 100% alag
    // Ek global panel banavo, body ma append karo
    // Original panel DOM ma rehse (hidden) - thi links extract karo
    // ===========================================================

    const teleport = document.createElement('ul');
    teleport.className = 'nav-teleport-dropdown';
    document.body.appendChild(teleport);

    let activeDetails = null;
    let closeTimer = null;

    const getLinks = (det) => {
      // Theme original panel thi links kado - any nested structure
      const origPanel = det.querySelector('ul, .header__submenu, .mega-menu');
      if (!origPanel) return [];
      // Direct anchor tags lo - nested levels handle karo
      return Array.from(origPanel.querySelectorAll('a')).map(a => ({
        href: a.href || a.getAttribute('href') || '#',
        text: a.textContent.trim()
      })).filter(l => l.text.length > 0);
    };

    const placePanel = (summaryEl) => {
      const rect = summaryEl.getBoundingClientRect();
      // Panel render thay pachhi size measure karva ek frame pachi
      requestAnimationFrame(() => {
        const pw = teleport.offsetWidth || 200;
        let left = rect.left;
        if (left + pw > window.innerWidth - 8) left = window.innerWidth - pw - 8;
        if (left < 8) left = 8;
        teleport.style.top = (rect.bottom + 4) + 'px';
        teleport.style.left = left + 'px';
      });
    };

    const openPanel = (det, summaryEl) => {
      clearTimeout(closeTimer);
      const links = getLinks(det);
      if (!links.length) return;

      teleport.innerHTML = links.map(l =>
        `<li><a href="${l.href}">${l.text}</a></li>`
      ).join('');

      // Off-screen render karvo size mate
      teleport.style.top = '-9999px';
      teleport.style.left = '-9999px';
      teleport.classList.add('open');
      placePanel(summaryEl);
      activeDetails = det;
    };

    const closePanel = (delay = 0) => {
      clearTimeout(closeTimer);
      if (delay > 0) {
        closeTimer = setTimeout(() => {
          teleport.classList.remove('open');
          teleport.innerHTML = '';
          activeDetails = null;
        }, delay);
      } else {
        teleport.classList.remove('open');
        teleport.innerHTML = '';
        activeDetails = null;
      }
    };

    // Drekha details par hover/click
    carousel.querySelectorAll('details').forEach(det => {
      const summary = det.querySelector('summary');
      if (!summary) return;

      // Summary click - toggle
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (activeDetails === det) {
          closePanel();
        } else {
          closePanel();
          openPanel(det, summary);
        }
      });

      // Mouse enter - hover open
      det.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        if (activeDetails !== det) {
          closePanel();
          openPanel(det, summary);
        }
      });

      // Mouse leave - delay thi bando karo (user teleport panel par jaay shake)
      det.addEventListener('mouseleave', (e) => {
        const to = e.relatedTarget;
        if (to && (teleport === to || teleport.contains(to))) return;
        closePanel(120);
      });
    });

    // Teleport panel hover - open rakhvo
    teleport.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    teleport.addEventListener('mouseleave', (e) => {
      const to = e.relatedTarget;
      if (to && to.closest && to.closest('#nav-carousel')) return;
      closePanel(120);
    });

    // Outside click - bando karo
    document.addEventListener('click', (e) => {
      if (!e.target.closest('#nav-carousel') && !e.target.closest('.nav-teleport-dropdown')) {
        closePanel();
      }
    });

    // ===========================================================
    // CAROUSEL SCROLL
    // ===========================================================
    const updateArrows = () => {
      const mo = maxOff();
      const overflow = mo > 2;
      if (prevBtn) prevBtn.style.display = (overflow && offset > 0) ? 'flex' : 'none';
      if (nextBtn) nextBtn.style.display = (overflow && offset < mo - 1) ? 'flex' : 'none';
    };

    const moveTo = (val) => {
      offset = clamp(val, 0, maxOff());
      carousel.style.transform = `translateX(-${offset}px)`;
      updateArrows();
      closePanel(); // Move thay to dropdown bando
    };

    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); moveTo(offset - STEP); });
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); moveTo(offset + STEP); });

    // Touch swipe
    let tx = 0;
    wrapper.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
    wrapper.addEventListener('touchend', e => {
      const d = tx - e.changedTouches[0].clientX;
      if (Math.abs(d) > 30) moveTo(offset + d);
    }, { passive: true });

    // Mouse drag
    let dragging = false, dx = 0, doff = 0;
    wrapper.addEventListener('mousedown', e => {
      if (e.target.closest('summary') || e.target.closest('a')) return;
      dragging = true; dx = e.clientX; doff = offset;
      wrapper.style.cursor = 'grabbing';
      e.preventDefault();
    });
    document.addEventListener('mousemove', e => { if (dragging) moveTo(doff + (dx - e.clientX)); });
    document.addEventListener('mouseup', () => { if (dragging) { dragging = false; wrapper.style.cursor = 'grab'; } });

    window.addEventListener('resize', () => { moveTo(offset); updateArrows(); closePanel(); });

    // Init
    requestAnimationFrame(() => setTimeout(() => { moveTo(0); updateArrows(); }, 150));
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let obs = new IntersectionObserver((entries, obs) => {
      this.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    obs.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(d => d.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
